import { Component, Inject } from "@angular/core";
import { MatIconButton } from "@angular/material/button";
import { MAT_DIALOG_DATA, MatDialogRef } from "@angular/material/dialog";
import { MatIcon } from "@angular/material/icon";

@Component({
    selector: "app-image-dialog",
    standalone: true,
    imports: [MatIcon, MatIconButton],
    templateUrl: "./image-dialog.component.html",
    styleUrl: "./image-dialog.component.scss"
})
export class ImageDialogComponent {
    imageDialog: string = "image-dialog";
    imageDialogCloseButton: string = "image-dialog-close-button";
    imageDialogActiveImage: string = "image-dialog-image";

    constructor(
        public dialogRef: MatDialogRef<ImageDialogComponent>,
        @Inject(MAT_DIALOG_DATA) public data: { activeImageSrc: string }
    ) {}

    closeImageDialog() {
        this.dialogRef.close();
    }
}
